/*
 * A reading's colour as the server measured it (routes/culture_colour.py,
 * migration 0112): CIELAB, D65. Only for showing: a swatch beside the numbers,
 * which are what's read. Nothing here measures.
 */
const WHITE = [0.95047, 1, 1.08883];
const fInv = t => (t ** 3 > 216 / 24389 ? t ** 3 : (116 * t - 16) / (24389 / 27));
const toSrgb = (c) => {
  const v = c <= 0.0031308 ? 12.92 * c : 1.055 * c ** (1 / 2.4) - 0.055;
  return Math.round(Math.min(1, Math.max(0, v)) * 255);
};

/** #rrggbb of {L, a, b}, clipped to what sRGB can show; null without a colour. */
export function labToHex(lab) {
  if (!lab) return null;
  const fy = (lab.L + 16) / 116;
  const x = WHITE[0] * fInv(fy + lab.a / 500);
  const y = WHITE[1] * fInv(fy);
  const z = WHITE[2] * fInv(fy - lab.b / 200);
  const rgb = [3.2404542 * x - 1.5371385 * y - 0.4985314 * z,
               -0.969266 * x + 1.8760108 * y + 0.041556 * z,
               0.0556434 * x - 0.2040259 * y + 1.0572252 * z];
  return `#${rgb.map(c => toSrgb(c).toString(16).padStart(2, '0')).join('')}`;
}

/** "L* 62.1  a* 3.2  b* 12.0" */
export const labText = lab => `L* ${lab.L.toFixed(1)}  a* ${lab.a.toFixed(1)}  b* ${lab.b.toFixed(1)}`;
